import * as React from 'react'
import { Link } from 'react-router-dom'

import Plus from '../../../components/icons/plus'
import SimilarPhoto from './similarPhoto'
import * as styles from './similarPhotos.module.css'

interface IItem {
  id: number
}

interface IProps {
  selectedItem: IItem
  items: IItem[]
  onItemClick: (event: any, item: any) => void
}

const renderPhotos = (props: IProps) => {
  const { selectedItem, items, onItemClick } = props

  return items
    .slice(0, 7)
    .map((item, i) => (
      <SimilarPhoto
        key={i}
        item={item}
        selected={item.id === selectedItem.id}
        onItemClick={onItemClick}
      />
    ))
}

const SimilarPhotos: React.StatelessComponent<IProps> = props => {
  const { selectedItem } = props
  const nextPageUrl = `/search/?item_id=${selectedItem.id}`
  return (
    <div className={styles.similarPhotosWrapper}>
      <div className={styles.label}>Similar Photos</div>
      <div className={styles.similarPhotos}>
        {renderPhotos(props)}
        <div className={styles.similarPhoto}>
          <div className={styles.morePhotosWrapper}>
            <Link className={styles.morePhotos} to={nextPageUrl}>
              <div className={styles.morePhotosIcon}>
                <Plus width="20" height="20" />
              </div>
              <div className={styles.morePhotosLabel}>View More</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SimilarPhotos
